import { ButtonProtected } from '@components'

import { useModal, withModalConditionalRender } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { Scope } from '../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'
import { useBankTransactionDrawer } from '../../../../contexts'
import { UnmatchConfirmationModal as UnmatchConfirmationModalComponent } from '../UnmatchConfirmationModal'

const UnmatchConfirmationModal = withModalConditionalRender(UnmatchConfirmationModalComponent)

export const UnmatchButton = (): ReactElement | null => {
  const { t } = useTranslation()
  const { selectedTransaction, updateSelectedTransaction } = useBankTransactionDrawer()
  const matchId = selectedTransaction?.match?.id

  const { open: openUnmatchModal } = useModal(ModalId.UnmatchConfirmationModal)

  const handleUnmatched = useCallback(() => {
    if (!selectedTransaction?.match) {
      return
    }
    updateSelectedTransaction({
      ...selectedTransaction,
      match: { ...selectedTransaction.match, isApproved: false },
    })
  }, [selectedTransaction, updateSelectedTransaction])

  if (!matchId) {
    return null
  }

  return (
    <>
      <ButtonProtected
        fullWidth
        onClick={openUnmatchModal}
        scopes={Scope.BankReconciliationWrite}
        trackingContext={TrackingContext.BankTransactions}
      >
        {t('bank_transactions.drawer.matched_state.cta')}
      </ButtonProtected>
      <UnmatchConfirmationModal id={ModalId.UnmatchConfirmationModal} matchId={matchId} onUnmatched={handleUnmatched} />
    </>
  )
}
